import React, { ChangeEvent } from 'react'
import { InputAdornment } from '@material-ui/core'
import { FieldNames } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { startAdornments, endAdornments, getValueIfPositiveInteger } from '../../../services/publishSchedule'
import { usePublishSchedule } from '../hooks'
import { StyledTextField } from '../styled'

export const EveryNthPeriod = () => {
  const [{ fieldValues, fieldErrors }, dispatch] = usePublishSchedule()
  return (
    <StyledTextField
      id="every-nth-period-input"
      margin="dense"
      type="number"
      InputProps={{
        startAdornment: <InputAdornment position="start">{startAdornments[fieldValues.recurrence]}</InputAdornment>,
        endAdornment: <InputAdornment position="end">{endAdornments[fieldValues.recurrence]}</InputAdornment>,
      }}
      value={fieldValues[FieldNames.everyNthPeriod] || ''}
      error={!!fieldErrors[FieldNames.everyNthPeriod]}
      helperText={fieldErrors[FieldNames.everyNthPeriod]}
      onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
        dispatch(setFieldValue(FieldNames.everyNthPeriod, getValueIfPositiveInteger(value)))
      }}
    />
  )
}
